import src from 'media/logo.png'
import { Button, Card, Input, Form } from 'antd'
import { useTranslation } from 'react-i18next'
import authService from 'authService'
import { useRouter } from '@uirouter/react'
import useLogin from './useLogin'

const LoginCard: React.FC = () => {
  const { t } = useTranslation()
  const { stateService } = useRouter()
  const { form, onClick, isLoading } = useLogin()

  function handleKeyUp(event) {
    // Enter
    if (event.keyCode === 13) {
      onClick()
    }
  }

  return (
    <div className="loginCard">
      <Card>
        <img alt="P" src={src} />
        <h3 style={{ textTransform: 'uppercase' }}>{t('LOGIN')}</h3>
        <p>{t('LOGIN_TITTLE')}</p>
        <Form
          layout="vertical"
          style={{ width: 340 }}
          form={form}
          onFinish={onClick}
        >
          <Form.Item
            label={t('USER')}
            name="user"
            rules={[
              {
                required: true,
                message: 'Ingrese un correo valido',
                type: 'email'
              }
            ]}
          >
            <Input placeholder="Juan Perez" />
          </Form.Item>
          <Form.Item
            label={t('PASSWORD')}
            name="password"
            rules={[{ required: true, message: 'Ingrese su contraseña' }]}
          >
            <Input type="password" placeholder="**********" />
          </Form.Item>

          <Form.Item label=" " style={{ display: 'none' }}>
            <Button style={{ display: 'none' }} htmlType="submit" />
          </Form.Item>
        </Form>
        <Button
          type="primary"
          onClick={() =>
            form
              .validateFields()
              .then(() => {
                form.submit()
              })
              .catch(() => {})
          }
          loading={isLoading}
        >
          {t('GETIN')}
        </Button>
      </Card>
    </div>
  )
}

export default LoginCard
